import { createContext, useContext } from 'react';

import type { TAuthActions } from '~context/auth/types';
import {
	DatadogLogger,
	LoggerMessages,
	LoggerServices,
} from '~shared/services/logger';
export const AuthContext = createContext<TAuthActions>({
	openRegister: () => undefined,
	openLogin: () => undefined,
});

export const useAuthActionsContext = () => {
	const context = useContext(AuthContext);
	if (!context) {
		DatadogLogger.error(
			LoggerServices.UserService,
			LoggerMessages.AuthContextError,
			{}
		);
		throw Error('Auth context no context Provider');
	}
	return context;
};
